<div class="card mt-4">
  <div class="card-header text-center"><small><b>Design Pressures</b></small></div>
  <div class="card-body">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th><small>Design Factor</small></th>
          <th><small>Max Design Pressure</small></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of designPressures">
          <td>{{item.designFactor}}</td>
          <td>
            <span class="me-2"><small>{{item.maxDesignPressure}}</small></span>
            <span class="ms-2"><small>({{item.inbar}})&nbsp;BAR</small></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
